module.exports = __webpack_public_path__ + "media/new_ui/apple-store-badge-958a3ff1.png";